export default "__VITE_ASSET__BDdq1seX__"